import {
  browserProfilingIntegration,
  browserTracingIntegration,
  captureMessage,
  init,
  moduleMetadataIntegration,
  setTags,
  setUser,
  vueIntegration,
} from '@sentry/vue'

export const setupSentry = (Vue: any, router: any, environment: string) => {
  if (environment !== 'production') return
  init({
    dsn: 'https://7c00453af52593014a07b67c76deef22@o176457.ingest.us.sentry.io/4507383910760448',
    environment,
    integrations: [
      vueIntegration({ app: Vue, tracingOptions: { trackComponents: true } }),
      browserTracingIntegration({
        router,
        enableInp: true,
        shouldCreateSpanForRequest: (url: string) => {
          return (
            url.includes('leadconnectorhq.com') || url.includes('msgsndr.com')
          )
        },
      }),
      browserProfilingIntegration(),
      moduleMetadataIntegration(),
    ],
    allowUrls: [/https?:\/\/((static|appcdn)\.)?leadconnectorhq\.com/],
    sampleRate: 0.2, // samples are picked randomly
    tracesSampleRate: 0.1, // picked randomly, starting with bare minimum
    tracePropagationTargets: [/https?:\/\/(.*)?leadconnectorhq\.com/],
  })
}

export interface SentryEvent {
  locationId: string
  locale: string
  email?: string
  userId?: string
  companyId?: string
}

export function setSentryMeta(event: SentryEvent) {
  try {
    setTags({
      locationId: event.locationId,
      locale: event.locale,
      companyId: event.companyId,
    })

    if (event?.email && event?.userId) {
      setUser({ id: event.userId, email: event.email })
    } else {
      setUser({})
    }
  } catch (err) {
    captureMessage(
      `Issue while setting sentry meta '${err}', please change to use hyphen '-'.`
    )
  }
}
